import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import { styled as muiStyled } from "@mui/system";

export const FontSectionContainer = muiStyled(Grid)<{
  isLargeScreen?: Boolean;
}>((theme: any) => ({
  display: "flex",
  alignItems: theme.isLargeScreen ? "center" : "flex-start",
  justifyContent: theme.isLargeScreen ? "flex-start" : "center",
  flexDirection: theme.isLargeScreen ? "row" : "column",
  marginTop: "15px",
}));

export const TextAlignSectionContainer = muiStyled(Grid)<{
  isLargeScreen?: Boolean;
}>((theme: any) => ({
  display: "flex",
  alignItems: theme.isLargeScreen ? "center" : "flex-start",
  justifyContent: theme.isLargeScreen ? "flex-start" : "center",
  flexDirection: theme.isLargeScreen ? "row" : "column",
  marginTop: "15px",
  gap: "10px",
}));

export const FontTitleSectionContainer = muiStyled(Box)<{
  isLargeScreen?: Boolean;
}>((theme: any) => ({
  marginBottom: theme.isLargeScreen ? "0px" : "10px",
  fontSize: "14px",
  width: 120,
}));

export const BackgroundTitleSectionContainer = muiStyled(Box)<{
  isLargeScreen?: Boolean;
}>((theme: any) => ({
  marginBottom: theme.isLargeScreen ? "0px" : "10px",
  fontSize: "14px",
}));

export const UploadSectionGridContainer = muiStyled(Grid)<{
  uploadState: Boolean;
}>((theme: any) => ({
  marginBottom: theme.uploadState ? "10px" : "15px",
  marginTop: "5px",
}));

export const ColorTitleSectionContainer = muiStyled(Box)<{
  isLargeScreen?: Boolean;
}>((theme: any) => ({
  marginBottom: theme.isLargeScreen ? "0px" : "10px",
  fontSize: "14px",
  width: 120,
}));

export const ColorPropertiesContainer = muiStyled(Box)<{
  isLargeScreen?: Boolean;
}>((theme: any) => ({
  width: theme.isLessThan1440 ? "100%" : "calc(100% - 120px)",
  display: "flex",
  alignItems: "center",
}));

export const ColorDetailsContainer = muiStyled(Box)({
  width: 170,
  display: "flex",
  alignItems: "center",
});

export const ColorEditButtonContainer = muiStyled(Box)({
  width: "calc(100% - 170px)",
  display: "flex",
  alignItems: "center",
  marginLeft: "20px",
});

export const ColorSectionContainer = muiStyled(Grid)<{
  isLargeScreen?: Boolean;
}>((theme: any) => ({
  display: "flex",
  alignItems: theme.isLargeScreen ? "center" : "flex-start",
  justifyContent: theme.isLargeScreen ? "flex-start" : "center",
  flexDirection: theme.isLargeScreen ? "row" : "column",
  marginTop: "15px",
}));

export const FileSectionContainer = muiStyled(Grid)({
  marginTop: "15px",
});

export const RadioLabelContainer = muiStyled("div")({
  fontFamily: "Poppins",
  fontSize: "13px",
});

export const RootContainer = muiStyled("div")({
  fontFamily: "Poppins",
  fontSize: "14px",
});

export const ColorTextContainer = muiStyled("div")({
  fontFamily: "Poppins",
  fontSize: "12px",
  width: "calc(100% - 80px)",
  marginLeft: "10px"
});

export const ChooseYourFileButtonGrid = muiStyled(Grid)({
  marginTop: "15px",
  marginBottom: "5px",
});
